module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_viesi-02010ee83398a72cee19f0f122b69592.webp";